import styled from "styled-components";

const AppViewPort = styled.div`
  position: relative;
  width: 100%;
  height: 100vh;
  background: ${({ theme }) => theme.colors.primary};
  overflow: hidden;
  @media only screen and (min-width: 768px) {
    max-width: 375px;
    height: 667px;
  }
`;

export default AppViewPort;



// WEBPACK FOOTER //
// ./src/components/AppViewPort.js